// URL and link validation utilities

export const validateUrl = (url) => {
  if (!url) return url;
  
  try {
    const parsed = new URL(url);
    // Only allow http and https protocols
    if (!['http:', 'https:'].includes(parsed.protocol)) {
      throw new Error('Invalid URL protocol');
    }
    return url;
  } catch (error) {
    throw new Error('Invalid URL format');
  }
};

export const sanitizeLink = (link) => {
  if (!link) return link;
  
  // Remove any HTML/script tags
  link = link.replace(/<[^>]*>/g, '');
  // Remove potential script injection characters
  link = link.replace(/['"\\]/g, '');
  return link.trim();
};

// Returns the URL only if it parses and uses a safe (http/https) protocol,
// otherwise null. Safe for direct use in an href/src without throwing, and
// blocks javascript:, data: and other script-capable schemes.
export const safeHttpUrl = (url) => {
  if (!url) return null;

  try {
    const value = String(url).trim();
    // Treat protocol-relative URLs (//host/path) as https so they validate
    // instead of throwing.
    const parsed = new URL(value.startsWith('//') ? `https:${value}` : value);
    return ['http:', 'https:'].includes(parsed.protocol) ? parsed.href : null;
  } catch (error) {
    return null;
  }
};

export const validateExternalLink = (link) => {
  // List of allowed external domains
  const allowedDomains = [
    'amazonaws.com',
    'cloudfront.net',
    // Add other allowed domains here
  ];

  try {
    const url = new URL(link);
    const domain = url.hostname;
    
    if (!allowedDomains.some(allowed => domain.endsWith(allowed))) {
      throw new Error('External domain not allowed');
    }
    
    return link;
  } catch (error) {
    throw new Error('Invalid external link');
  }
};